import {
  DocumentPdfRegular,
  DocumentRegular,
  ImageRegular,
  TableRegular,
} from '@/components/Icon'

/**
 * @param {string} fileName
 */
export function getDocumentExtensionLabel(fileName) {
  const match = fileName.match(/\.([^.]+)$/)
  return match ? match[1].toUpperCase() : 'FILE'
}

/**
 * @param {import('./documentsDemoData').DocumentItem['category']} category
 */
export function getDocumentTypeIcon(category) {
  switch (category) {
    case 'xls':
      return TableRegular
    case 'images':
      return ImageRegular
    case 'document':
      return DocumentPdfRegular
    default:
      return DocumentRegular
  }
}

/**
 * @param {import('./documentsDemoData').DocumentItem['category']} category
 * @returns {'docs' | 'xls' | 'images' | 'pdf' | 'default'}
 */
export function getDocumentIconTone(category) {
  switch (category) {
    case 'docs':
      return 'docs'
    case 'xls':
      return 'xls'
    case 'images':
      return 'images'
    case 'document':
      return 'pdf'
    default:
      return 'default'
  }
}
